import { StyleSheet } from "react-native";
import { theme } from "@lookiero/sty-psp-ui";

const style = () => {
  const { space4, space6 } = theme();

  return StyleSheet.create({
    container: {
      marginBottom: space4,
    },
    smallContainer: {
      marginHorizontal: space6,
    },
    underlinedText: {
      textDecorationLine: "underline",
    },
  });
};

export { style };
